import React, { useEffect } from 'react';
import Hero from '../components/Hero';
import ChaosToClarity from '../components/ChaosToClarity';
import HowItWorks from '../components/HowItWorks';
import FutureVision from '../components/FutureVision';
import Footer from '../components/Footer';
import ParticlesBackground from '../components/ParticlesBackground';
import StickyHeader from '../components/StickyHeader';

const LandingPage = () => {
  useEffect(() => {
    // Force scroll to top on mount/refresh
    window.scrollTo(0, 0);
    // Prevent browser from restoring previous scroll position
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  return (
    <main className="relative min-h-screen bg-[#050505]">
      <StickyHeader />
      <ParticlesBackground />
      <Hero />
      <ChaosToClarity />
      <HowItWorks />
      <FutureVision />
      <Footer />
    </main>
  );
};

export default LandingPage;
